import React, { useEffect } from 'react'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import Filters from '../../../../components/elements/Filters'
import ArrowUpTrayIcon from '../../../../components/elements/icons/ArrowUpTrayIcon'
import EmptyState from '../../../../components/elements/EmptyState'
import { useState } from 'react'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import NewSubject from '../../../../components/partials/subjects/NewSubject'
import { useDispatch, useSelector } from 'react-redux'
import { clearCreatedSubject, clearDeletedSubject, deleteSubject, fetchSubjects } from '../../../../store/actions/subjectsActions'
import Pagination from '../../../../components/elements/Pagination'
import TrashIcon from '../../../../components/elements/icons/TrashIcon'
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon'
import { Link } from 'react-router-dom'

const Subjects = () => {

    const filterOptions = [
      {
        name: 'date applied',
        linkType: 'option',
        link: ['is after', 'is before'],
        type: 'date',
        value: "",
        displayValue: ""
      }
    ]
    const dispatch = useDispatch()
    const subjectsSelector = useSelector(state => state.subjects)
    const [creatingSubject, setCreatingSubject] = useState(false)
    const [reload, setReload] = useState(0)
    // eslint-disable-next-line no-unused-vars
    const [filters, setFilters] = useState('')
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(25)


    useEffect(() => {
      dispatch(fetchSubjects(filters, page, perPage))
      if(subjectsSelector.createdSubject !== null) {
        dispatch(clearCreatedSubject())
        setCreatingSubject(false)
      }

      if(subjectsSelector.deletedSubject !== null) {
        dispatch(clearDeletedSubject())
      }
    
      return () => {
        
      }
    }, [reload, dispatch, filters, page, perPage, subjectsSelector.createdSubject, subjectsSelector.deletedSubject])

    const doDelete = (id) => {
      if(window.confirm('This subject will be deleted from the system. Please confirm to continue')){
        dispatch(deleteSubject(id))
      }
    }
    

    return (
      <>
        <div className='w-full'>
          <div className="w-full mx-auto flex items-center justify-between">
            <div className='w-8/12'>
                <h4 className='font-medium text-lg mb-3 text-gray-600'>Subjects</h4>
                <div className='w-2/3'>
                    <p className='text-gray-500 my-3 text-sm'>
                        Set up all subjects for the college here. You can click on a subject to see more details and create or change curriculum.
                    </p>
                </div>
            </div>
            <div className='w-4/12 flex flex-row-reverse'>
                <button onClick={()=>{setCreatingSubject(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                    <PlusIcon className='w-5 h-5' /> Create subject
                </button>
            </div>
          </div>

          <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
            <div className='w-full'>
              <Filters filterOptions={filterOptions} />
            </div>
            <div className='w-4/12 flex flex-row-reverse gap-x-2'>
              <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                <ArrowUpTrayIcon className={`w-5 h-5`} />
                Export Subjects List
              </button>
            
            </div>
          </div>

          {/* {staffSelector?.loadingStaff ? 
            <Loader />
            : */}
            <>
              {subjectsSelector?.subjects?.subjects?.length > 0 ? 
                <div className=''>
                    <>
                      <div className='mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1'>
                        {subjectsSelector?.subjects?.subjects?.map((subject, subjectIndex)=>(
                          <div key={subjectIndex} className='w-full p-[20px] rounded bg-gray-50'>
                            <p className='font-space-grotesk font-[550]'>{subject.name} {subject.shortName && <span className='text-sm text-gray-600'>({subject.shortName})</span>}</p>
                            <p className='text-sm text-gray-700 mt-[5px]'>{subject.description}</p>

                            <p className='text-xs text-gray-500 mb-[5px] mt-[10px]'>Classes</p>
                            <div className='flex items-center gap-x-[5px] flex-wrap mt-[10px]'>
                              {subject.classes.map((subjectClass, subjectClassIndex) => (
                                <span key={subjectClassIndex} className='px-[10px] py-[5px] text-[13px] font-space-grotesk font-[500] bg-gray-200 bg-opacity-50 text-gray-500'>{subjectClass?.class?.name}</span>
                              ))}
                            </div>
                            <div className="w-full flex items-center justify-between mt-5 border-t pt-3">
                              <Link to={subject._id} className='text-sm flex flex-row items-center gap-x-2 text-vcm-purple hover:text-gray-400 transition duration-200'>View Subject Details<ArrowIcon className={`w-4 h-4`} /></Link> 

                              <button onClick={()=>{doDelete(subject._id)}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                <TrashIcon className={`w-5 h-5`} />
                              </button>
                          </div>
                          </div>
                        ))}
                      </div>
                      <Pagination 
                        pagination={{
                          perPage, 
                          page,
                          totalItems: subjectsSelector?.subjects?.total,
                        }} 
                        changePage={setPage} 
                        updatePerPage={setPerPage}
                      />
                    </>
                </div>
                : 
                <div className='mt-24 w-1/2 mx-auto'>
                  <EmptyState emptyStateText={`No subjects available yet`} />
                </div>
              }
            </>
          {/* } */}
        </div>

        <ModalDialog
          shown={creatingSubject} 
          closeFunction={()=>{setCreatingSubject(false)}} 
          actionFunction={()=>{}} 
          actionFunctionLabel={``}
          dialogTitle='Create a new subject'
          maxWidthClass='max-w-xl'
          hideActions={true}
        >
          <NewSubject 
            reload={()=>{setReload(reload+1)}}
            close={()=>{setCreatingSubject(false)}}
          />
        </ModalDialog>
      </>
    )
}

export default Subjects